import './js/vendor';
import {MulliganRouter, MulliganController} from './routes';
import UserStore from './js/stores/user-store';
import Dispatcher from './js/dispatcher';
window.Routes = MulliganRouter;
window.Mulligan = {};
import localeUtils from './js/utils/locales';
import Brands from './js/utils/brands';
import Utils from './js/utils/utils';
import './vst-ui/import.js';
import './img';
import chameleonjs from "chameleonjs";

const Branding = {

  setup() {
    document.body.setAttribute('data-theme', Mulligan.Brand.theme);
    if (Mulligan.Brand.jigsawHost){
      Jigsaw.host = Mulligan.Brand.jigsawHost;
      Mulligan.Brand.jigsawHost = "//" + Mulligan.Brand.jigsawHost + "/";
    }
    const user = UserStore.get();
    const newlocale = localStorage.getItem('updateLanguageOnLogin');
    if (user) {
      if (newlocale && newlocale !== "false") {
        localeUtils.changeLocale(newlocale);
        Jigsaw.User.setInfo({email: user.email, locale: newlocale}, (response) => {
          if (response.isSuccess()){
            localStorage.removeItem('updateLanguageOnLogin')
          } else {
            if (response.message !== "Unauthorized") {
              localStorage.removeItem('updateLanguageOnLogin')
            }
          }
        });
      } else if (user.locale) { // null locale means no set locale, ingore it
        localeUtils.changeLocale(user.locale);
      }
    } else {
      localeUtils.changeLocale(Mulligan.Brand.locale);
    }
  }

}

const Setup = {

  init() {
    Mulligan.brandParam = Utils.getParameterByName('brand');
    if (Mulligan.brandParam.length === 0){ Mulligan.brandParam = false }
    Mulligan.brandParam = Mulligan.brandParam || Brands[window.location.hostname] || false;

    this.render(this);
    Dispatcher.once(Dispatcher.USER_STORE_CHANGE, this._loadUserBrand);
  },

  loadChameleonBrand(brand) {
    return chameleonjs.loadBrand(brand, "mulligan")
    .then(json => {
      return json;
    })
    .catch((error) => {
      return false;
    });
  },

  async loadDefaultBrand(callback) {
    if (!Mulligan.Brand){
      const response = await this.loadChameleonBrand(Mulligan.brandParam || "vitalsource");
      if (response) {
        Mulligan.Brand = response;
        Branding.setup();
        callback();
      } else {
        Jigsaw.getBrandConfig(Mulligan.brandParam || 'vitalsource', (response) => {
          if (response.isSuccess()){
            Mulligan.Brand = response;
          } else {
            Mulligan.brandParam = false;
            this.loadDefaultBrand(callback);
            return;
          }
          Branding.setup();
          callback();
        });
      }

    } else {
      callback();
    }
  },

  async _loadUserBrand() {
    let user = UserStore.get();

    if (user && !this.userBrandLoaded){
      this.userBrandLoaded = true;
      const response = await Setup.loadChameleonBrand(Mulligan.brandParam || user.lastBrandAccessed);
      if (response) {
        Mulligan.Brand = response || Mulligan.Brand;
        Branding.setup();
        Dispatcher.emit(Dispatcher.BRAND_CHANGE);
      } else {
        Jigsaw.getBrandConfig(Mulligan.brandParam || user.lastBrandAccessed, (response)=>{
          if (response.isSuccess()){
            Mulligan.Brand = response || Mulligan.Brand;
          }
          Branding.setup();
          Dispatcher.emit(Dispatcher.BRAND_CHANGE);
        });
      }
    } else {
      Dispatcher.emit(Dispatcher.BRAND_CHANGE);
    }
  },

  _setupFavIcon() {
    var link = document.createElement('link');
    link.type = 'image/png';
    link.rel = 'shortcut icon';

    // If `brand` param is present, we're in branding tool preview so omit the
    // protocal and location host.
    link.href = Mulligan.Brand.Graphics.favicon;
    let href = document.createElement("a");
    href.href = link.href;
    if (href.hostname === window.location.hostname || href.hostname === ""){
      link.href = "https://bookshelf.vitalsource.com"+Mulligan.Brand.Graphics.favicon;
    }
    document.getElementsByTagName('head')[0].appendChild(link);
  },

  render(setup) {
    MulliganController.loader();

    setup.loadDefaultBrand(()=>{
      this._loadUserBrand();
      Dispatcher.on(Dispatcher.BRAND_CHANGE, () => {
        this._setupFavIcon();
        Routes.init('/');
      });
    });
  }

}

Setup.init();



/** WEBPACK FOOTER **
 ** ./src/index.jsx
 **/